import React from 'react'
import {sortPhotos} from 'lib/imageUtils'
import SelectPhotoAssets from 'components/shared/SelectPhotoAssets'
import Button from 'components/shared/Button'

const SelectPhotos = ({product, photoOrder, selectedPhotos, setSelectedPhotos, setStep}) => {
  const photoAssets = product.inputAssets.edges
    .map(e => e.node)
    .filter(p => p.__typename === 'PhotoAsset')

  const photos = photoOrder ? sortPhotos(photoAssets, photoOrder) : photoAssets

  const choosePhotosDescriptionText = () => {
    const inputAssetsLength = photos.length
    const minQuantity = product.quantity

    let description = inputAssetsLength > 1
      ? 'Vi har tatt flere bilder.'
      : 'Vi har tatt ett bilde.'

    description += minQuantity > 1
      ? ` Velg ut de ${minQuantity} du vil ha redigert.`
      : ' Velg det du vil ha redigert.'

    if (inputAssetsLength > minQuantity) {
      description += ` Du kan velge flere enn ${minQuantity}, da vil ekstrakostnaden bli lagt til ordren.`
    }

    return description
  }

  return (
    <div className="retouched-photo-product provide-input select-photos">
      <p>{choosePhotosDescriptionText()}</p>

      <SelectPhotoAssets
        product={product}
        photos={photos}
        minQuantity={product.quantity}
        selectedPhotos={selectedPhotos}
        onSelection={setSelectedPhotos}
      />

      <div className="actions">
        <Button
          type="navigation"
          disabled={selectedPhotos.length === 0}
          onClick={() => setStep('confirm')}
        >
          Se over valgte bilder ({selectedPhotos.length})
        </Button>
      </div>
    </div>
  )
}

export default SelectPhotos
